<script setup>
import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

// 编辑器实例，必须用 shallowRef，重要！
const editorRef = shallowRef()

// 内容 HTML
const valueHtml = ref('<p>hello</p>')

// 模拟 ajax 异步获取内容
onMounted(() => {
  setTimeout(() => {
    valueHtml.value = ''
  }, 1500)
})

// 编辑器配置
const editorConfig = {
  placeholder: '请输入内容...',
  MENU_CONF: {
    uploadImage: {
      // 后端上传地址，必填
      server: "/dev-api/common/upload",

      timeout: 5 * 1000, // 5s 超时时间

      fieldName: 'custom-fileName',

      //选择文件时的类型限制，默认为['image/*'] 如不想限制，则设置为 []
      allowedFileTypes: ['image/*'],

      metaWithUrl: true, // 参数拼接到 url 上

      maxFileSize: 1000 * 1024 * 1024, //1g //设置大点 不然图片过大会报错

      base64LimitSize: 1000000 * 1024, // 1g 以下插入 base64

      // 上传前
      onBeforeUpload(file) {
        console.log('onBeforeUpload', file)
        // Message({
        //                 message: '图片正在上传中,请耐心等待',
        //                 duration: 0,
        //                 customClass: 'uploadTip',
        //                 iconClass: 'el-icon-loading',
        //                 showClose: true
        //               });
        return file.url // 返回哪些文件可以上传
        // return false 会阻止上传
      },
      // uploadImage: {   //上传图片配置
      //   customUpload: handleUpload
      // },
      // uploadVideo: {  //上传视频配置
      //   customUpload: handleUpload
      // }
    },

    // 上传进度的回调函数
    onProgress(progress) {
      console.log('onProgress', progress)
    },
    // 单个文件上传成功之后
    onSuccess(file, res) {
      console.log('onSuccess', file.url, res)
    },
    // 单个文件上传失败
    onFailed(file, res) {
      alert(res.message)
      console.log('onFailed', file, res)
    },
    // 上传错误，或者触发 timeout 超时
    onError(file, err, res) {
      alert(err.message)
      console.error('onError', file, err, res)
    },
  },
}

const handleCreated = (editor) => {
  editorRef.value = editor // 记录 editor 实例，重要！
}

// 组件销毁时，及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

defineExpose({valueHtml})
</script>

<template>
    <div style="border: 1px solid #ccc">
        <!-- 工具栏 -->
        <Toolbar
                :editor="editorRef"
                :defaultConfig="toolbarConfig"
                style="border-bottom: 1px solid #ccc"
        />
        <!-- 编辑器 -->
        <Editor
                v-model="valueHtml"
                :defaultConfig="editorConfig"
                style="height: 500px; overflow-y: hidden;"
                @onCreated="handleCreated"
        />
    </div>
</template>

<!-- 别忘了引入样式 -->
<style src="@wangeditor/editor/dist/css/style.css"></style>